import React from 'react';

import Carregando from 'apresentacao/Carregando';

export default function CarregandoInput() {
  return <Carregando size="sm" thickness="2px" color="gray.500" />;
}
